export enum AccessLevelEnum {
  AllCollaborators = 0,
  DirectTeamAndSpecificCollaborators = 1,
  SpecificCollaborators = 2,
  DirectTeam = 3,
}
